import React from "react";
import { Button } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { RenderWhen } from "../../../../../components";
import { Analysis } from "../../../@types";
import { ANALYSIS_MAP } from "./consts";
import { determineStatus, isProcessing } from "./utils";

type Props = {
  errors: Array<string>;
  isRetryable: boolean;
  status: string;
  analysis: Analysis;
  onResubmit: () => void;
};

const Error: React.FC<Props> = ({
  analysis,
  errors,
  isRetryable,
  status,
  onResubmit
}) => {
  const processing = isProcessing(status);

  return (
    <>
      <section className="flex flex-column width-100-pc">
        <div className="flex width-100-pc align-center">
          <div className="flex width-50-pc">
            <div className="width-50-pc bold">
              {ANALYSIS_MAP[analysis]} status:
            </div>
            <div className="flex flex-gap-2 width-50-pc">
              <RenderWhen condition={processing}>
                <Spinner
                  data-testid="processing-spinner"
                  size="sm"
                  animation="border"
                  variant="secondary"
                />
              </RenderWhen>
              {determineStatus(status)}
            </div>
          </div>
          <div className="width-50-pc">
            <RenderWhen condition={isRetryable}>
              <Button
                test-dataid={`${analysis}-resend-button`}
                onClick={onResubmit}
                size="sm"
              >
                Resubmit
              </Button>
            </RenderWhen>
          </div>
        </div>
        <RenderWhen condition={Boolean(errors.length)}>
          <div className="flex width-50-pc m-top-4">
            <hr />
            <div className="width-50-pc bold">
              {analysis.toUpperCase()} errors:
            </div>
            <div className="flex flex-column width-50-pc">
              {errors.map((error, index) => (
                <div key={index}>{error}</div>
              ))}
            </div>
          </div>
        </RenderWhen>
      </section>
    </>
  );
};
export default Error;
